import React from "react";

const factsData = [
  {
    img: "/img/icons/bx-heart.svg",
    number: "10K+",
    text: "Happy Customers",
  },
  {
    img: "/img/icons/bx-car.svg",
    number: "150+",
    text: "Well-Maintained Cars",
  },
  {
    img: "/img/icons/bx-headphone.svg",
    number: "24/7",
    text: "Customer Support",
  },
  {
    img: "/img/icons/bx-history.svg",
    number: "5L+",
    text: "Kilometers Travelled",
  },
];

const FactsNumber = () => {
  return (
    <section className="section facts-number">
      
      {/* Left Image */}
      <div className="facts-left">
        <img
          src="/img/bg/facts-left.png"
          className="img-fluid"
          alt="Omshree Cab service"
        />
      </div>

      {/* Right Image */}
      <div className="facts-right">
        <img
          src="/img/bg/facts-right.png"
          className="img-fluid"
          alt="Omshree Cab cars"
        />
      </div>

      <div className="container">
        
        {/* Heading */}
        <div className="section-heading" data-aos="fade-down">
          <h2 className="title text-white">Omshree Cab in Numbers</h2>
          <p className="description">
            Trusted cab service providing safe, reliable, and comfortable rides
            for local and outstation travel.
          </p>
        </div>

        {/* Counter Section */}
        <div className="counter-group">
          <div className="row">
            {factsData.map((fact, index) => (
              <div
                className="col-lg-3 col-md-6 col-12 d-flex"
                data-aos="fade-down"
                key={index}
              >
                <div className="count-group flex-fill">
                  <div className="customer-count d-flex align-items-center">
                    
                    <div className="count-img">
                      <img src={fact.img} alt="Icon" />
                    </div>

                    <div className="count-content">
                      <h4>{fact.number}</h4>
                      <p>{fact.text}</p>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default FactsNumber;